var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSeafood = function SvgSeafood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Seafood_svg__clip0_1811_218057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.082 10.728s.05-2.319-1.765-2.657c-1.69-.315-5.143.336-8.288 3.607a1.613 1.613 0 00-.347 1.674l.454 1.23 9.946-3.854z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.556 10.087c-3.045 0-3.58-1.25-3.582-1.255-1.269.573-2.634 1.481-3.945 2.845a1.613 1.613 0 00-.347 1.674l.454 1.23 7.147-2.77.273-1.724z",
    fill: "url(#Seafood_svg__paint0_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.102 10.516h-.004a.28.28 0 01-.275-.286l.01-.884a.28.28 0 01.279-.28h.003a.28.28 0 01.275.286l-.01.885a.28.28 0 01-.278.28zM15.072 10.518a.279.279 0 01-.267-.2l-.248-.832a.283.283 0 01.185-.353.278.278 0 01.347.189l.249.831a.283.283 0 01-.266.365z",
    fill: "#529DE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.996 12.557a.277.277 0 01-.236-.132l-.437-.702a.285.285 0 01.086-.39.276.276 0 01.384.088l.438.702a.285.285 0 01-.087.39.275.275 0 01-.148.044z",
    fill: "#D88A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.441 19.771s-.332 2.205-2.288 2.226c-1.28.015-3.374-1.436-4.667-2.44a2.008 2.008 0 01-.644-2.28l.294-.797 7.305 3.291z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.134 17.328l-3.052-6.598a5.32 5.32 0 00-2.526-.64c-2.772 0-5.813 2.12-7.708 3.714v3.46c1.895 1.594 4.936 3.714 7.708 3.714 2.736 0 4.571-2.064 5.578-3.65z",
    fill: "url(#Seafood_svg__paint1_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.652 19.172c-8.23.242-10.413-6.465-10.413-6.465-.508.37-.977.744-1.39 1.092v3.46c1.894 1.595 4.935 3.715 7.707 3.715 1.712 0 3.071-.809 4.096-1.802z",
    fill: "url(#Seafood_svg__paint2_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.848 13.8c-.263.222-.505.434-.72.628a.762.762 0 01-1.222-.297l-.005-.012.051 2.889.003-.006a.763.763 0 011.23-.316c.201.18.423.373.663.575 0-.865.766-.865.766-1.73s-.766-.865-.766-1.73z",
    fill: "#7CB9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.811 12.176a.817.817 0 00-.811.823c0 .243.03.479.085.704a8.205 8.205 0 010 3.945c-.055.225-.085.461-.085.704 0 .455.363.823.811.823.559 0 1.08-.444 1.518-1.015 1.216-1.583 1.144-3.84-.225-5.288-.388-.41-.827-.696-1.293-.696z",
    fill: "url(#Seafood_svg__paint3_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.93 15.858a.787.787 0 000-.647c-.395-.878-1.652-3.313-3.848-4.48v3.5c0 1.71 1.367 3.097 3.052 3.097.386-.607.65-1.145.796-1.47z",
    fill: "url(#Seafood_svg__paint4_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.676 17.317c0 .962.648 1.767 1.537 1.973a.755.755 0 00.707-.209l1.336-1.351a.59.59 0 000-.827l-1.336-1.351a.755.755 0 00-.707-.209 2.007 2.007 0 00-1.537 1.974z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.676 17.317c0 .962.648 1.768 1.537 1.974a.755.755 0 00.707-.21l.397-.401c-1.934-.813-1.104-3.336-1.104-3.336a2.006 2.006 0 00-1.537 1.973z",
    fill: "url(#Seafood_svg__paint5_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.752 14.527a.276.276 0 01-.205-.091l-.612-.673a.286.286 0 01.016-.399.275.275 0 01.393.016l.612.672a.286.286 0 01-.015.4.275.275 0 01-.19.075zM4.14 18.074a.275.275 0 01-.19-.075.286.286 0 01-.015-.4l.612-.672a.275.275 0 01.393-.016c.113.106.12.285.016.4l-.612.672a.276.276 0 01-.205.09zM4.636 15.963h-.344a.28.28 0 01-.279-.282.28.28 0 01.279-.283h.344a.28.28 0 01.279.283.28.28 0 01-.279.283z",
    fill: "#529DE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.98 15.098a.28.28 0 01-.278-.282v-.467a.28.28 0 01.278-.283.28.28 0 01.279.283v.467a.28.28 0 01-.279.282z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.55 17.064a.273.273 0 01-.071-.01l-.555-.15a.283.283 0 01-.197-.347c.04-.15.192-.24.34-.2l.556.151a.283.283 0 01-.072.556zM14.995 18.283a.283.283 0 01-.072-.556l.556-.15c.148-.041.3.048.34.199a.283.283 0 01-.196.346l-.555.15a.273.273 0 01-.072.01z",
    fill: "#529DE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.198 7.163a1.715 1.715 0 012.37 0 .422.422 0 010 .61.455.455 0 01-.63 0 .805.805 0 00-1.11 0l-.63-.61z",
    fill: "url(#Seafood_svg__paint6_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.198 8.475a1.715 1.715 0 012.37 0 .422.422 0 010 .61.455.455 0 01-.63 0 .805.805 0 00-1.11 0l-.63-.61z",
    fill: "url(#Seafood_svg__paint7_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.244 9.086l-3.366 1.222a.552.552 0 00-.23.896 6.474 6.474 0 002.517 1.677c.242.089.514.011.668-.19l1.616-2.104a3.322 3.322 0 01-1.205-1.501z",
    fill: "url(#Seafood_svg__paint8_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.416 4.606h3.382V.773H6.455C3.715.773 1.373 2.43.437 4.766a.606.606 0 00.399.801l4.345 1.321c.441-1.324 1.722-2.282 3.235-2.282z",
    fill: "url(#Seafood_svg__paint9_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.03c0 1.123.305 2.176.838 3.087.16.271.5.389.802.28l3.604-1.31a3.198 3.198 0 01-.063-2.199L.918 5.592a.66.66 0 00-.848.518c-.046.3-.07.608-.07.92z",
    fill: "url(#Seafood_svg__paint10_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.608 15.145c.379-1.478.207-2.474-.669-2.901.876-.428 1.048-1.423.669-2.901-.203-.79-2.02-1.298-1.997-.308.022.986-.507 1.683-1.2 2.04a.938.938 0 00-.517.83v.678c0 .348.2.666.518.83.692.357 1.221 1.054 1.199 2.04-.023.99 1.794.482 1.997-.308z",
    fill: "url(#Seafood_svg__paint11_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.894 12.581c0 .349.2.666.518.83.692.357 1.221 1.054 1.199 2.04-.023.99 1.794.482 1.997-.307.379-1.479.207-2.474-.669-2.902H7.894v.339z",
    fill: "url(#Seafood_svg__paint12_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.553 12.243c0-.314 1.248-.9 2.941-.9 1.694 0 1.644.9 1.644.9s.05.9-1.644.9c-1.693 0-2.941-.586-2.941-.9z",
    fill: "url(#Seafood_svg__paint13_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45 10.586l-1.597 2.079a.295.295 0 00.176.467c.459.1.936.154 1.425.154h.808c.637 0 1.153-.5 1.153-1.118 0-.512-.359-.953-.869-1.084-.399-.102-.77-.272-1.097-.498z",
    fill: "url(#Seafood_svg__paint14_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36 6.504h-.808c-1.852 0-3.354-1.456-3.354-3.252C4.198 1.456 5.7 0 7.552 0h5.07c1.02 0 1.685 1.036 1.235 1.923l-.924 1.82c-.857 1.69-2.63 2.76-4.573 2.76z",
    fill: "url(#Seafood_svg__paint15_linear_1811_218057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.879 2.553c.432 0 .783-.34.783-.76a.771.771 0 00-.783-.758.771.771 0 00-.783.759c0 .419.35.759.783.759z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint0_linear_1811_218057",
    x1: 12.25,
    y1: 9.249,
    x2: 12,
    y2: 11.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint1_linear_1811_218057",
    x1: 15.75,
    y1: 10.001,
    x2: 13.25,
    y2: 21.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint2_linear_1811_218057",
    x1: 8.75,
    y1: 13.997,
    x2: 15.206,
    y2: 20.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint3_linear_1811_218057",
    x1: 4.897,
    y1: 12.119,
    x2: 1.561,
    y2: 17.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BBAF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint4_linear_1811_218057",
    x1: 18.382,
    y1: 11.76,
    x2: 22.182,
    y2: 13.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529DE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint5_linear_1811_218057",
    x1: 13.878,
    y1: 15.963,
    x2: 16.337,
    y2: 17.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint6_linear_1811_218057",
    x1: 4.202,
    y1: 7.293,
    x2: 6.781,
    y2: 7.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#FC482B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2B3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint7_linear_1811_218057",
    x1: 4.202,
    y1: 8.605,
    x2: 6.781,
    y2: 8.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE860A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#FC482B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2B3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint8_linear_1811_218057",
    x1: 4.557,
    y1: 9.487,
    x2: 2.347,
    y2: 10.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1514F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint9_linear_1811_218057",
    x1: 7.437,
    y1: 1.413,
    x2: 3.411,
    y2: 4.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1514F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint10_linear_1811_218057",
    x1: 1.202,
    y1: 9.787,
    x2: 3.393,
    y2: 9.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint11_linear_1811_218057",
    x1: 9.704,
    y1: 16.145,
    x2: 12.838,
    y2: 14.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint12_linear_1811_218057",
    x1: 8.549,
    y1: 12.561,
    x2: 8.451,
    y2: 14.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1514F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint13_linear_1811_218057",
    x1: 8.549,
    y1: 12.339,
    x2: 10.819,
    y2: 12.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint14_linear_1811_218057",
    x1: 5.623,
    y1: 12.926,
    x2: 7.072,
    y2: 12.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Seafood_svg__paint15_linear_1811_218057",
    x1: 6.445,
    y1: 5.636,
    x2: 10.25,
    y2: 4.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA9A8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Seafood_svg__clip0_1811_218057"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Seafood.33d0bc75.svg";
export { SvgSeafood as ReactComponent };